/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Video_Complete_ToastInputs */

const en_audio_description_export_video_complete_toast = /** @type {(inputs: Audio_Description_Export_Video_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video with Audio Description exported successfully`)
};

const fr_audio_description_export_video_complete_toast = /** @type {(inputs: Audio_Description_Export_Video_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vidéo avec description audio exportée avec succès`)
};

const de_audio_description_export_video_complete_toast = /** @type {(inputs: Audio_Description_Export_Video_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video mit Audiobeschreibung erfolgreich exportiert`)
};

const it_audio_description_export_video_complete_toast = /** @type {(inputs: Audio_Description_Export_Video_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video con descrizione audio esportato correttamente`)
};

const ru_audio_description_export_video_complete_toast = /** @type {(inputs: Audio_Description_Export_Video_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видео с аудиоописанием успешно экспортировано.`)
};

const es_audio_description_export_video_complete_toast = /** @type {(inputs: Audio_Description_Export_Video_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vídeo con descripción de audio exportado correctamente`)
};

const zh_cn2_audio_description_export_video_complete_toast = /** @type {(inputs: Audio_Description_Export_Video_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已成功导出带有音频描述的视频`)
};

const ja_audio_description_export_video_complete_toast = /** @type {(inputs: Audio_Description_Export_Video_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音声説明付きのビデオが正常にエクスポートされました`)
};

const hi_audio_description_export_video_complete_toast = /** @type {(inputs: Audio_Description_Export_Video_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो विवरण सहित वीडियो सफलतापूर्वक निर्यात हो गया है।`)
};

const pt_pt2_audio_description_export_video_complete_toast = /** @type {(inputs: Audio_Description_Export_Video_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vídeo com audiodescrição exportado com sucesso.`)
};

/**
* | output |
* | --- |
* | "Video with Audio Description exported successfully" |
*
* @param {Audio_Description_Export_Video_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_video_complete_toast = /** @type {((inputs?: Audio_Description_Export_Video_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Video_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_video_complete_toast(inputs)
	if (locale === "de") return de_audio_description_export_video_complete_toast(inputs)
	if (locale === "it") return it_audio_description_export_video_complete_toast(inputs)
	if (locale === "ru") return ru_audio_description_export_video_complete_toast(inputs)
	if (locale === "es") return es_audio_description_export_video_complete_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_video_complete_toast(inputs)
	if (locale === "ja") return ja_audio_description_export_video_complete_toast(inputs)
	if (locale === "hi") return hi_audio_description_export_video_complete_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_video_complete_toast(inputs)
	return en_audio_description_export_video_complete_toast(inputs)
});